const langtrans={
      gywmm:["关于我们","About us"],
      xwzzx:["新闻中心","Press Center"],
      qqjylm:["全球救援联盟","Global Assistance Alliance"],
	  xssffw1:["星使服务","Xingshi service"],
      xssffw:["星使服务是由江泰救援自研自建的本地服务，我们拥有完整的服务模式和星使培训体系，截至目前已经有近一千名熟悉本地服务的星使分布在全球各地，为国人提供当地救援、救助、陪同、向导、翻译、法律援助、住院安排、医疗就诊、转运等线上线下服务。依托于江泰救援平台，星使可以自行设定服务项目，自动接收来自国人的有酬求助、陪同邀请等。服务亿万国人的同时，还能赚取一笔收益，快来加入星使团队吧。","Xingshi service is local service developed by Jiangtai Assistance. We have a complete service mode and Xingshi training system. By now, there have been nearly 1000 Xingshis spreading all over the world, who are familiar with local geography, to provide Chinese with Assistance, assistance, company, guidance, translation, legal assistance, arrangements for admission, medical treatment, transferring and other on-line or off-line services. Relying on Jiangtai Assistance, Xingshi may set service project at discretion and receive appeals and company invitation for value from Chinese. Besides, Xingshis may earn money. Come and join us. "],
      rhhcww:["如何成为星使？","How to become a Xingshi?"],
      xzzddj:["下载大救星","Download Dajiuxing"],
      sjgnsj:["手机：国内手机从各大应用市场如360手机助手等应用下载，国外手机从","Android: Download from varied App store inland, such as 360 Phone Assistant or from GooglePlay abroad."],
      xzz:["下载；","Download"],
      ppgsjc:["苹果手机：从","Apple Phone"],
      yycwwx:["要成为星使，需要进行以下5步操作。","To become a Xingshi, the following five steps are needed:"],
      txxsjh:["填写手机号码点击下一步。","en_translated"],
      sdyzmh:["收到验证码后输入验证码、设置密码登录成为用户。","en_translated"],
      ddjzss:["点击左上角找到星使认证。","en_translated"],
      yctxxx:["依次填写星使认证相关资料。","en_translated"],
      zltxxw:["资料填写完成后点击右上角“提交”，等待星使认证审核。","en_translated"],
      xsszlt:["星使资料提交成功后，我们会在48小时内审核您的资料，通过审核后，系统会有相关信息通过大救星平台通知您。","en_translated"],
      jyjgdl:["救援机构登录成功","en_translated"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","en_translated"],
      dlsbwz:["登录失败，未知错误","en_translated"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/stars.vue.trans.js